export default __webpack_public_path__ + "56437b25b9d4c2e4e971939bcd543a68.png";